import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './services/modal.service';
import { ModalWindow } from './components/window/window.component';
import { ModalBackdrop } from './components/backdrop/backdrop.component';
import { ModalStackService } from './services/modal-stack.service';
import { ModalComponent } from './components/modal/modal.component';
import { FormModalComponent } from './components/form-modal/form-modal.component';
import { SetValuesPipe } from './pipes/set-values.pipe';
import { FormsModule } from '../forms';
import { ActiveModal } from './classes/active-modal';
import { LaddaModule } from 'angular2-ladda';

@NgModule({
    imports: [
        CommonModule, FormsModule, LaddaModule
    ],
    declarations: [
        ModalWindow,
        ModalBackdrop,
        ModalComponent,
        FormModalComponent,
        SetValuesPipe,
    ],
    entryComponents: [
        ModalWindow,
        ModalBackdrop,
    ],
    providers: [
        ModalService,
        ActiveModal,
    ],
    exports: [
        ModalComponent,
        FormModalComponent,
        ModalWindow,
        ModalBackdrop,
        SetValuesPipe,
        CommonModule,
    ],
})
export class ChassisModalModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ChassisModalModule,
            providers: [
                ModalService,
                ModalStackService
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/modals.module.ts